import(/* webpackMode: "eager" */ "/vercel/path0/components/SendPasswordResetForm/component.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/legacy/image.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js")